import { render, staticRenderFns } from "./RonovatecView.vue?vue&type=template&id=8feefb62&"
import script from "./RonovatecView.vue?vue&type=script&lang=ts&"
export * from "./RonovatecView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports